<template>
  <div class="alertBox">
    <notification @close="closeNotification(index)"
                  :notification="notification"
                  :position="index"
                  v-for="(notification, index) in reverseModalNotifications"
                  :key="index"></notification>
  </div>
</template>

<style scoped>
.alertBox {
  display: block;
  z-index: 9999;
  top: 20px;
  height:auto;
}

</style>

<script>
  import { mapGetters } from 'vuex'
  import * as types from '../store/mutation-types'
  import Notification from './Notification'

  export default {
    computed: {
      ...mapGetters([
        'reverseModalNotifications'
      ])
    },

    methods: {
      closeNotification (index) {
        this.$store.commit(types.HIDE_MODAL_NOTIFICATION, index)
      }
    },

    components: {
      Notification
    }
  }
</script>



// WEBPACK FOOTER //
// ModalNotifications.vue?1f92d84d